var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-drawer',{attrs:{"title":"保险理赔单详情","visible":_vm.visible,"width":"80vw","maskClosable":false},on:{"close":_vm.onClose}},[_c('div',{staticClass:"settlement-info"},[_c('div',{staticClass:"info-item"},[_c('span',{staticClass:"info-label"},[_vm._v("结算状态：")]),_c('span',{staticClass:"font-size-lg",class:_vm.getStatusColorClass()},[_vm._v(_vm._s(_vm.settlementStatus))])]),_c('div',{staticClass:"info-item"},[_c('span',{staticClass:"info-label"},[_vm._v("结算总金额：")]),_c('span',[_vm._v("¥"+_vm._s(_vm.settlementTotalAmount))])])]),_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.tableData,"pagination":false,"scroll":{ x: true },"rowKey":(record) => record.orderinforawId,"bordered":""}}),_c('div',{style:({
      position: 'absolute',
      bottom: 0,
      width: '100%',
      borderTop: '1px solid #e8e8e8',
      padding: '10px 16px',
      textAlign: 'right',
      left: 0,
      background: '#fff',
      borderRadius: '0 0 4px 4px',
    })},[_c('a-button',{staticStyle:{"marginright":"8px"},on:{"click":_vm.onClose}},[_vm._v(" 关闭 ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }